import React from "react"

import IconCheck from "@/app/(site)/_components/Atoms/Icons/IconCheck"
import {
    SearchFilter,
    Values,
    ValuesFilterMeta
} from "@/lib/depict-client/types/api/ProductListingRequestV3"
import Text from "../../../../Atoms/Text"
import { filterConfig } from "../../types/options" // Import the filter operation types

type FilterCheckboxProps = {
    item: Values
    field: string
    op: "eq" | "neq" | "in" | "nin" | "leq" | "geq" | "inrange"
    isSelected: boolean
    isSizeFilter: boolean
    valueIndex: number
    filter: SearchFilter
    onAddFilter: (
        field: string,
        op: SearchFilter["op"],
        value: string,
        e: React.ChangeEvent<HTMLInputElement>
    ) => void
}

const FilterCheckbox = ({
    item,
    field,
    op,
    isSelected,
    valueIndex,
    isSizeFilter,
    filter,
    onAddFilter
}: FilterCheckboxProps) => {
    const uniqueId = `${field}-${item}`

    const colorMap =
        field === filterConfig[1].field
            ? (filter.meta as ValuesFilterMeta)?.values?.reduce(
                  (map: any, color: any, index: number) => {
                      map[color.toLowerCase()] =
                          (filter.meta as ValuesFilterMeta)?.swatches?.[index] ??
                          "#ffffff"
                      return map
                  },
                  {}
              )
            : undefined

    const itemStyle =
        typeof item === "string" && field === filterConfig[1].field
            ? colorMap[(item as string).toLowerCase()]
            : isSelected
              ? "black"
              : "white"

    const itemLabel = isSizeFilter
        ? item
        : (filter.meta as ValuesFilterMeta)?.names?.[valueIndex] || ""

    const count = (filter.meta as ValuesFilterMeta).counts?.[valueIndex] || 0
    const isClickable = count > 0

    return (
        <div
            className={`relative flex items-center gap-8 ${!isClickable && "cursor-not-allowed opacity-50"}`}
            role="checkbox"
            aria-checked={Boolean(isSelected)}
            aria-disabled={!isClickable}
        >
            <input
                id={uniqueId}
                type="checkbox"
                className="absolute left-0 top-0 h-24 w-24 cursor-pointer rounded-full opacity-0"
                onChange={e => {
                    if (isClickable) {
                        onAddFilter(
                            field ?? "",
                            op as SearchFilter["op"],
                            String(item),
                            e
                        )
                    }
                }}
                checked={Boolean(isSelected)}
                disabled={!isClickable}
                aria-label={`Select ${itemLabel}`} // Descriptive aria-label for the checkbox
                aria-checked={Boolean(isSelected)}
                aria-disabled={!isClickable}
            />
            <div
                className={`flex h-24 w-24 items-center justify-center rounded-full border ${
                    isSelected ? "border-transparent" : "border-main-black"
                }`}
                style={{
                    backgroundColor: String(itemStyle) // Convert itemStyle to a string
                }}
            >
                {isSelected && <IconCheck className="h-16 w-16 text-main-white" />}
            </div>
            <label
                htmlFor={uniqueId}
                className={`cursor-pointer select-none ${!isClickable && "pointer-events-none"}`}
                aria-hidden={!isClickable}
            >
                <Text size="medium" weight="regular">
                    {itemLabel}
                </Text>
            </label>
        </div>
    )
}

export default FilterCheckbox
